import { useConsent } from '@/lib/consent';
import { isOpenAIAdsConfigured } from './client';

/** Consent-aware OpenAI Ads enablement: true only when consent allows and env config is valid. */
export const useOpenAIAdsEnabled = (): boolean => {
  const { allowed } = useConsent();
  return allowed && isOpenAIAdsConfigured();
};
